function initLocalMessagesCache() {
    let assistantRefPrompts = [];
    return {
        getAssistantRefPrompts: ()=>assistantRefPrompts,
        setAssistantRefPrompts: (msg, msgs)=>{
            if (msgs && Array.isArray(msgs)) assistantRefPrompts = msgs;
            else if (msg) assistantRefPrompts.push(msg);
        }
    };
}
const localCache = initLocalMessagesCache();
export { localCache };
